import {
  Container,
  ContentWrapper,
  LeftImageContainer,
  Link,
  RightImageContainer,
  StyledButton,
  Text
} from './styles'
import { SupportBannerProps } from './SupportBannerContainer.types'

const SupportBanner = ({
  des,
  button,
  leftBackgroundImageUrl,
  rightBackgroundImageUrl,
  style
}: SupportBannerProps) => {
  return (
    <Container style={style}>
      {leftBackgroundImageUrl && (
        <LeftImageContainer
          role='img'
          aria-label='left background image'
          backgroundImage={leftBackgroundImageUrl}
        />
      )}
      <ContentWrapper data-testid='content-wrapper'>
        <Text>{des}</Text>
        <Link href={button.href}>
          <StyledButton
            variant='secondary'
            heightClass='large'
            style={button.style}
          >
            {button.label}
          </StyledButton>
        </Link>
      </ContentWrapper>
      {rightBackgroundImageUrl && (
        <RightImageContainer
          role='img'
          aria-label='right background image'
          backgroundImage={rightBackgroundImageUrl}
        />
      )}
    </Container>
  )
}

export default SupportBanner
